module.exports = __webpack_public_path__ + "img/introduction.af298805.png";